export default "__VITE_ASSET__9K$bBCKm__"